import { render, staticRenderFns } from "./proPost1.vue?vue&type=template&id=fdb13346&scoped=true&"
import script from "./proPost1.vue?vue&type=script&lang=js&"
export * from "./proPost1.vue?vue&type=script&lang=js&"
import style0 from "./proPost1.vue?vue&type=style&index=0&id=fdb13346&scoped=true&lang=css&"
import style1 from "./proPost1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb13346",
  null
  
)

export default component.exports